import { css } from "@emotion/react";
import styled from "@emotion/styled";

type ContainerProps = {
  $isOverlayHidden: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: absolute;
  z-index: 10;

  display: ${props => (props.$isOverlayHidden ? "none" : "flex")};

  inline-size: 100%;
  block-size: 100vh;
  padding-block: 22px 15px;

  background-color: rgba(0, 0, 0, 0.6);
`;

type ButtonAreaProps = {
  $type: "next" | "previous";
};

export const ButtonArea = styled.div<ButtonAreaProps>`
  display: flex;
  flex-direction: column;
  gap: 25px;
  justify-content: center;
  align-items: center;

  block-size: 100%;

  ${props => {
    switch (props.$type) {
      case "previous":
        return css`
          inline-size: 25%;
          border-inline-end: 1px dashed #c5bdbd;
        `;
      case "next":
        return css`
          inline-size: 75%;
          border-inline-end: none;
        `;
    }
  }}
`;

export const Label = styled.div`
  color: #ffffff;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.001em;
  text-transform: capitalize;
`;
